import script from "./CounterpartiesAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./CounterpartiesAdmin.vue?vue&type=script&setup=true&lang=js"

import "./CounterpartiesAdmin.vue?vue&type=style&index=0&id=56a8b1be&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56a8b1be"]])

export default __exports__